import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import api from '../../services/api';

const EditCILModal = ({ show, handleClose, cil, handleSave }) => {
    const [broker_id, setBrokerId] = useState('');
    const [developer_sales_id, setDeveloperSalesId] = useState('');
    const [project, setProject] = useState('');
    const [unitCode, setUnitCode] = useState('');
    const [status, setStatus] = useState('');

    useEffect(() => {
        if (cil) {
            setBrokerId(cil.broker_id);
            setDeveloperSalesId(cil.developer_sales_id);
            setProject(cil.project);
            setUnitCode(cil.unitCode);
            setStatus(cil.status);
        }
    }, [cil]);

    const handleSaveClick = () => {
        const updatedCil = {
            ...cil,
            broker_id,
            developer_sales_id,
            project,
            unitCode,
            status,
        };
        api.put(`/cil/${updatedCil.id}`, updatedCil)
        handleSave(updatedCil);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit CIL</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="broker_id">
                        <Form.Label>Broker ID</Form.Label>
                        <Form.Control
                            type="text"
                            value={broker_id}
                            onChange={(e) => setBrokerId(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="developer_sales_id">
                        <Form.Label>Developer ID</Form.Label>
                        <Form.Control
                            type="text"
                            value={developer_sales_id}
                            onChange={(e) => setDeveloperSalesId(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="project">
                        <Form.Label>Project</Form.Label>
                        <Form.Control
                            type="text"
                            value={project}
                            onChange={(e) => setProject(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="unitCode">
                        <Form.Label>Unit Code</Form.Label>
                        <Form.Control
                            type="text"
                            value={unitCode}
                            onChange={(e) => setUnitCode(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="status">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            as="select"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option>Approved</option>
                            <option>Pending</option>
                            <option>Rejected</option>
                        </Form.Control>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSaveClick}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCILModal;
